import Work1 from './assets/work1.jpg';
import Work2 from './assets/work2.jpg';
import Work3 from './assets/work3.jpg';
import Work4 from './assets/work4.jpg';
import Work5 from './assets/work5.jpg';

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "Star Wars Planets Search",
    git: "https://github.com/rayandersonsousa/project-starwars-planets-search",
    app: "https://starwars-planets-search-rayanderson.vercel.app/",
  },
  {
    id: 2,
    image: Work2,
    title: "Car Shop",
    git: "https://github.com/rayandersonsousa/project-car-shop",
    app: "indisponivel",
  },
  {
    id: 3,
    image: Work3,
    title: "Tryunfo",
    git: "https://github.com/rayandersonsousa/project-tryunfo",
    app: "indisponivel",
  },
  {
    id: 4,
    image: Work4,
    title: "Front-end Online Store",
    git: "https://github.com/rayandersonsousa/project-frontend-online-store",
    app: "indisponivel",
  },
  {
    id: 5,
    image: Work5,
    title: "Trybe Tunes",
    git: "https://github.com/rayandersonsousa/project-trybetunes",
    app: "indisponivel",
  },
];

export default projectsData;
